import consumer from "./consumer"

consumer.subscriptions.create("ConversationChannel", {
  received(data) {
    console.log("CONVERSATIOOOOON!");
    console.log(data);
  }
})